import * as React from 'react';
import { ErrorNotification, SuccessNotification } from '@verclam/toast-v2';

/** `eventName` matches the `type` of the actions dispatched by `Application/Roles/**`. */
const RolesNotifications: React.FC = () => {
	return (
		<React.Fragment>
			<SuccessNotification
				eventName="ROLE_CREATED"
				title="Rôle créé"
				message="Le rôle a bien été créé."
			/>
			<SuccessNotification
				eventName="ROLE_UPDATED"
				title="Rôle modifié"
				message="Le rôle a bien été modifié."
			/>
			<SuccessNotification
				eventName="ROLE_DELETED"
				title="Rôle supprimé"
				message="Le rôle a bien été supprimé."
			/>
			<ErrorNotification
				eventName="ROLE_CREATION_FAILED"
				title="Erreur"
				message="Le rôle n’a pas pu être créé."
			/>
			<ErrorNotification
				eventName="ROLE_UPDATE_FAILED"
				title="Erreur"
				message="Le rôle n’a pas pu être modifié."
			/>
			<ErrorNotification
				eventName="ROLE_DELETION_FAILED"
				title="Erreur"
				message="Le rôle n’a pas pu être supprimé."
			/>
			<ErrorNotification
				eventName="ROLES_FETCH_FAILED"
				title="Erreur"
				message="La liste des rôles n’a pas pu être chargée."
			/>
			<ErrorNotification
				eventName="PERMISSION_CATALOG_FETCH_FAILED"
				title="Erreur"
				message="Le catalogue des permissions n’a pas pu être chargé."
			/>
		</React.Fragment>
	);
};

export default RolesNotifications;
